import { createStore } from 'vuex';

const store = createStore({
  state: {
    loggedIn: false,
    user: {
        userName: '',
        email: '',
        availableTokens: null,
        tokenId: null,

        savedTemplates: [
          
        ]
        
    },

    createdCards: [
        
    ]

  },

//   mutations: {
//     updateGlobalVariable(state, newValue) {
//       state.globalVariable = newValue;
//     },
//   },
//   actions: {
//     updateGlobalVariable({ commit }, newValue) {
//       commit('updateGlobalVariable', newValue);
//     },
//   },
//   getters: {
//     getGlobalVariable: (state) => state.globalVariable,
//   },
});

export default store;